import { Fragment, useEffect, useState } from 'react';
import { CommonLoading } from 'react-loadingg';
import { UserDetailHeader, UserDetails } from '.';

const Report = (props) => {
    const [cognitoUsers, setCognitoUsers] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Report') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }
        }
    }, [props.loginList]);

    useEffect(() => {
        const getCognitoUsers = async () => {
            const cognitoUsersFromServer = await fetchCognitoUsers();
            setCognitoUsers(cognitoUsersFromServer);
        };

        getCognitoUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchCognitoUsers = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/report/getuserlist'
        );
        const data = await res.json();
        // Map id into the list to have unique key
        const formattedData = data.BBoardList.map((item, index) => {
            item.id = index;
            return item;
        });
        return formattedData;
    };

    const ReportList = () => {
        return (
            <Fragment>
                {cognitoUsers.length > 0 ? (
                    <UserDetails users={cognitoUsers} />
                ) : (
                    <div>No users has been created</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <UserDetailHeader />
                        <p style={{ marginLeft: '5px' }}>
                            NOT Applicable to Active Directory User
                        </p>
                        <div className='table-wrapper'>
                            <ReportList />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default Report;
